import React from "react";

export default function SQL_DELETE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_DELETE</h1>
      <p>This is the SQL_DELETE component generated from the SQL JSON.</p>
    </div>
  );
}
